import { types as t } from 'mobx-state-tree';

import { careerSitelanguages } from '@locale/locale-store';

import { Department } from 'models/departments/Department';
import { JobLabel } from 'models/jobs';
import { Location } from 'models/locations/Location';
import { WorkType } from 'models/workTypes/WorkType';

const CompanyTrigger = t.model('CompanyTrigger', {
  name: t.identifier,
  statuses: t.array(t.string),
});

export const CompanyInfo = t
  .model('CompanyInfo', {
    banner: t.maybeNull(t.string),
    companyName: t.string,
    defaultLanguage: t.enumeration('CompanyLanguage', careerSitelanguages),
    email: t.maybeNull(t.string),
    gaTracker: t.maybeNull(t.optional(t.string, '')),
    isEnterprise: t.boolean,
    isDeadlineRequired: t.boolean,
    ssnValidation: t.boolean,
    languages: t.string,
    logo: t.maybeNull(t.string),
    locations: t.array(Location),
    departments: t.array(Department),
    workTypes: t.maybeNull(t.array(WorkType)),
    jobLabels: t.maybeNull(t.array(JobLabel)),
    name: t.string,
    useSsnRegistry: false,
    use2FA: false,
    useForceSso: false,
    numStages: t.number,
    stage1Name: 'Stage 1',
    stage2Name: 'Stage 2',
    stage3Name: 'Stage 3',
    stage4Name: 'Stage 4',
    stage5Name: 'Stage 5',
    stage6Name: 'Stage 6',
    theme: t.frozen(),
    url: t.string,
    isHiredTriggers: t.array(CompanyTrigger),
  })
  .views((self) => ({
    get langs() {
      if (self.languages) {
        return self.languages.split(',');
      }
      return [];
    },
  }))
  .actions((self) => ({
    setName(name) {
      self.companyName = name;
    },
    setUrl(url) {
      self.url = url;
    },
    toggleSsnValidation() {
      self.ssnValidation = !self.ssnValidation;
    },
    setLanguage(lang) {
      self.defaultLanguage = lang;
    },
    setLanguages(langs) {
      const keys = langs ? Object.keys(langs).filter((key) => langs[key]) : [];
      if (!keys.includes(self.defaultLanguage) && keys.length > 0) {
        self.defaultLanguage = keys[0];
      }
      self.languages = keys.join(',');
    },
  }));
